import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useFacilities() {
  const [facilities, setFacilities] = useState([]);
  const load = useCallback(() => api.get("/facilities").then((r) => setFacilities(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  return [facilities, load];
}
